module.exports = __webpack_public_path__ + "img/POP-00009-1.41a58659.png";